import object from 'helpers/object'


export const initialState = {
  step: 'learn',
  stepData: null,
  total: null,
  accrued: null,
  recalcCount: null,
  groups: [],
  subscriber: null,
  categories: [],
  isTotalFetching: true,
  isFetching: true,
  redirectUrl: null,
  toMonth: null,
}


export const setGroups = (state, payload) => (
  object.setIn(state, [ 'groups' ], payload)
)

export const setRedirectUrl = (state, payload) => (
  object.setIn(state, [ 'redirectUrl' ], payload)
)

export const setSubscriber = (state, payload) => (
  object.setIn(state, [ 'subscriber' ], payload)
)

export const setStep = (state, payload) => (
  object.setIn(state, [ 'step' ], payload)
)

export const setStepData = (state, payload) => (
  object.setIn(state, [ 'stepData' ], payload)
)

export const setTotal = (state, payload) => (
  object.setIn(state, [ 'total' ], payload)
)

export const setAccrued = (state, payload) => (
  object.setIn(state, [ 'accrued' ], payload)
)

export const setRecalcCount = (state, payload) => (
  object.setIn(state, [ 'recalcCount' ], payload)
)

export const setToMonth = (state, payload) => (
  object.setIn(state, [ 'toMonth' ], payload)
)

export const setFetching = (state, payload) => (
  object.setIn(state, [ 'isFetching' ], payload)
)

export const setTotalFetching = (state, payload) => (
  object.setIn(state, [ 'isTotalFetching' ], payload)
)

export const setCategories = (state, payload) => (
  object.setIn(state, [ 'categories' ], payload)
)
